<div translate class="sem-dados-grid" *ngIf="total_registros === 0">
  {{'gridview.NenhumRegistroExibir'}}
</div>
<div class="header-grid" [class.com-filtro]="ListagemComFiltros"
  *ngIf="visualizarTotalRegistros && total_registros > 0 ">
  <div translate class="header-grid-qtd align-middle">
    {{'gridview.totalRegistros'}}
    <ng-container>
      {{total_registros}}
    </ng-container>
  </div>
  <div class="header-grid-qtd-pag" *ngIf="Paginacao">
    <select class="form-control form-control-sm" [(ngModel)]="registrosPagina" (change)="mudarQtdPorPagina()">
      <option translate value="5">{{'gridview.5registros'}}</option>
      <option translate value="10">{{'gridview.10registros'}}</option>
      <option translate value="15">{{'gridview.15registros'}}</option>
      <option translate value="20">{{'gridview.20registros'}}</option>
      <option translate value="30">{{'gridview.30registros'}}</option>
      <option translate value="40">{{'gridview.40registros'}}</option>
      <option translate value="50">{{'gridview.50registros'}}</option>
      <option translate value="100">{{'gridview.100registros'}}</option>
      <option translate value="500">{{'gridview.500registros'}}</option>
    </select>
  </div>
  <div class="clear"></div>
</div>
<div #TABLE>
  <table class="table table-sm table-hover table-striped gridview" *ngIf="total_registros > 0"
    [class.maior-2-colunas]="Estrutura.length > 2" [class.maior-4-colunas]="Estrutura.length >= 4"
    [class.maior-6-colunas]="Estrutura.length > 6" [class.maior-8-colunas]="Estrutura.length > 8"
    [class.maior-10-colunas]="Estrutura.length > 10" [class.com-borda]="Borda">
        <!-- Estrutura do Totalizador Internas -->
    <thead class="thead-dark" *ngIf="ExibirEstruturaItem">
      <tr>
        <th class="btn-ver-empty">
        </th>
        <th *ngFor="let coluna of EstruturaItem" appColunaGrid [coluna]="coluna" [style.background]="(coluna.getColor)?coluna.getColor():''" [style.border-color]="(coluna.getColor)?coluna.getColor():''" [style.width]="coluna.getWidth()">
          {{coluna.getHeaderText()}} &nbsp;
        </th>
      </tr>
    </thead>
    <thead class="thead-dark">
      <tr>
        <th class="" *ngIf="ExibirBotaoDetalhes">
          <span *ngIf="ExibirBotaoDetalhesIcon" class="badge badge-light" (click)="ExportTOExcel()">
            <img width="10" height="10" src="assets/img/btnDownload.svg"/>
          </span>
        </th>
        <th *ngFor="let coluna of Estrutura" appColunaGrid [coluna]="coluna"> {{coluna.getHeaderText() | translate}}
          <!-- <em class="fas fa-sort-alpha-down"></em> &nbsp; -->
          <a (click)="coluna.getTitleAction()" title="Ver Detalhes {{coluna.getHeaderText()}}"
            [hidden]="coluna.getHeaderText() ==='Serviços' ||  coluna.getHeaderText() ==='Peças'">
            <!-- Icones de cabeçalho - RMPV para acessar os RMPV Detalhes -->
            <em *ngIf="coluna.isAction()" class="fa fa-plus-square"></em>
          </a>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="linha-grid" *ngFor="let registro of linhas" [@animacaoPagina]="bindingVar">
        <td class="btn-ver" *ngIf="ExibirBotaoDetalhes">
          <a (click)="visualizar(registro)" href="javascript:;" title="Ver Detalhes">
            <div *ngIf="ExibirIconBotaoDetalhes">
              <img src="assets/img/detail.png"/>
            </div>
          </a>
        </td>
        <td *ngFor="let coluna of Estrutura" appColunaGrid [coluna]="coluna">

          <div class="dado" > 
            <ng-template appConteudoColunaGrid [coluna]="coluna" [registro]="registro" ng-model="registro" >
            </ng-template>
          </div>
          <div class="clear"></div>
        </td>
      </tr>
    </tbody>
    <!-- Estrutura do Totalizador Internas -->
    <thead class="thead-dark" *ngIf="totalInterna">
      <tr>
        <th class="btn-ver" *ngIf="ExibirBotaoDetalhes">
        </th>
        <th *ngFor="let coluna of EstruturaInterna" appColunaGrid [coluna]="coluna" [style.width]="coluna.getWidth()">
          {{coluna.getHeaderText() | translate}} &nbsp;
        </th>
      </tr>
    </thead>
    <!-- Estrutura do Totalizador Greal -->
    <thead class="thead-dark" *ngIf="totalInterna">
      <tr>
        <th class="btn-ver" scope="col" *ngIf="ExibirBotaoDetalhes">
        </th>
        <th *ngFor="let coluna of EstruturaTotal" appColunaGrid [coluna]="coluna" [style.width]="coluna.getWidth()">
          {{coluna.getHeaderText() | translate}} &nbsp;</th>
      </tr>
    </thead>
  </table>
</div>
<br>
<br>
<div class="paginacao" *ngIf="Paginacao && ultimaPagina > 1">
  <div class="float-right">
    <div class="botao">
      <button type="button" class="btn btn-outline-info btn-sm" (click)="irPrimeiraPagina()"
        [disabled]="PaginaAtual === 1">
        << </button> </div> <div class="botao">
          <button type="button" class="btn btn-outline-info btn-sm" (click)="irPaginaAnterior()"
            [disabled]="PaginaAtual === 1">
            < </button> </div> <div class="campo">
              {{'gridview.pagina' | translate}}
              <input type="text" class="form-control form-control-sm text-center"
                style="width: 60px; display: inline-block;" (blur)="irPagina()" [(ngModel)]="PaginaAtual" />
              {{'gridview.de' | translate}} {{ultimaPagina}}
    </div>
    <div class="botao">
      <button type="button" class="btn btn-outline-info btn-sm" (click)="irPaginaPosterior()"
        [disabled]="PaginaAtual === ultimaPagina">
        >
      </button>
    </div>
    <div class="botao">
      <button type="button" class="btn btn-outline-info btn-sm" (click)="irUltimaPagina()"
        [disabled]="PaginaAtual === ultimaPagina">
        >>
      </button>
    </div>
    <div class="clear"></div>
  </div>
  <div class="clear"></div>
</div>